export default __webpack_public_path__ + "images/0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7.png";